// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2qpmz","footer":"Form_footer__2pOS-"};